import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';
import {match} from 'ts-pattern';

import {GetSeriesListApiResponse} from '../types';

const getSeriesResponseMock: GetSeriesListApiResponse = [
  {
    id: '9e4f87ac-182f-466c-b3c4-6eb61dcaf3d7',
    name: 'rec ggg',
    type: 'warehouse/receipt',
    patterns: [
      {
        prefix: 'N',
        startingNumber: 1111111,
        length: 10,
        from: '2024-08-14',
        to: null,
        state: 'not_used',
      },
    ],
    firstIssueInfo: null,
    lastIssueInfo: null,
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '8290bb7e-21ea-4d9b-9966-8bd9f17f3947',
    name: 'Výdej',
    type: 'warehouse/dispense',
    patterns: [
      {
        prefix: 'VYD',
        startingNumber: 1,
        length: 8,
        from: '2024-05-27',
        to: null,
        state: 'in_use',
      },
    ],
    firstIssueInfo: {
      number: 'VYD00001',
      issuedAt: '2024-07-30T14:36:47+00:00',
    },
    lastIssueInfo: {
      number: 'VYD00023',
      issuedAt: '2024-12-11T13:54:08+00:00',
    },
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '727d0e9d-edeb-44e8-b3d3-eca3dae1781c',
    name: 'Issue / Dispense',
    type: 'warehouse/dispense',
    patterns: [
      {
        prefix: 'ISS',
        startingNumber: 1,
        length: 8,
        from: '2023-08-04',
        to: null,
        state: 'in_use',
      },
    ],
    firstIssueInfo: {
      number: 'ISS00001',
      issuedAt: '2023-08-10T09:40:07+00:00',
    },
    lastIssueInfo: {
      number: 'ISS01686',
      issuedAt: '2024-12-18T09:49:55+00:00',
    },
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '5568682c-62de-4d4f-80cc-9fb38d710815',
    name: 'Prijemka / Receipt',
    type: 'warehouse/receipt',
    patterns: [
      {
        prefix: 'RN',
        startingNumber: 1,
        length: 8,
        from: '2023-04-28',
        to: null,
        state: 'in_use',
      },
    ],
    firstIssueInfo: {
      number: 'RN000001',
      issuedAt: '2023-05-02T15:13:06+00:00',
    },
    lastIssueInfo: {
      number: 'RN000520',
      issuedAt: '2024-12-18T10:48:10+00:00',
    },
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '468b11a9-93ee-449c-bb2f-2fb7e2d3e98a',
    name: 'Issue note correction',
    type: 'warehouse/issue-note-correction',
    patterns: [
      {
        prefix: 'INC',
        startingNumber: 1,
        length: 16,
        from: '2024-11-15',
        to: null,
        state: 'not_used',
      },
    ],
    firstIssueInfo: null,
    lastIssueInfo: null,
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '427f583f-b951-4132-b7f1-a06ec1e86585',
    name: 'correction aaaa',
    type: 'warehouse/corrective-receipt',
    patterns: [
      {
        prefix: 'DDD',
        startingNumber: 1,
        length: 12,
        from: '2024-09-10',
        to: null,
        state: 'in_use',
      },
    ],
    firstIssueInfo: {
      number: 'DDD000000001',
      issuedAt: '2024-09-20T12:10:08+00:00',
    },
    lastIssueInfo: {
      number: 'DDD000000077',
      issuedAt: '2024-12-11T12:29:11+00:00',
    },
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: '2e0caf26-b2bd-4c43-928f-c26542781e71',
    name: 'test',
    type: 'warehouse/dispense',
    patterns: [
      {
        prefix: 'asd',
        startingNumber: 1,
        length: 8,
        from: '2024-12-16',
        to: null,
        state: 'not_used',
      },
    ],
    firstIssueInfo: null,
    lastIssueInfo: null,
    unique: true,
    system: false,
    withPrefix: false,
  },
  {
    id: 'edb9ce58-a659-429e-995c-58309d8ed496',
    name: 'Service Order Issue Note',
    type: 'workshop/service_order_issue',
    patterns: [
      {
        prefix: 'SO',
        startingNumber: 1,
        length: 8,
        from: '2023-08-29',
        to: null,
        state: 'in_use',
      },
    ],
    firstIssueInfo: {
      number: 'SO000001',
      issuedAt: '2023-10-05T10:24:28+00:00',
    },
    lastIssueInfo: {
      number: 'SO000305',
      issuedAt: '2024-12-13T10:33:22+00:00',
    },
    unique: true,
    system: false,
    withPrefix: false,
  },
];

const getSeriesResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/dms/v1/series*', ({request}) => {
      const url = new URL(request.url);
      const type = url.searchParams.getAll('type');

      return match(type)
        .with(
          [
            'warehouse/receipt',
            'warehouse/dispense',
            'warehouse/corrective-receipt',
            'warehouse/issue-note-correction',
            'workshop/service_order_issue',
          ],
          () => HttpResponse.json(getSeriesResponseMock)
        )
        .otherwise(() => HttpResponse.json());
    })
  );

export const seriesApiMock = {
  getSeriesResponseMock,
  getSeriesResponseInterceptor,
};
